module.exports = __webpack_public_path__ + "images/花筑村全景_08-3.jpg?v=b3d06d74";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_08-3.jpg
 ** module id = 102
 ** module chunks = 1 2
 **/